const styles = {
  header: {
    padding: "0px 10px 0px 0px",
    background: "#FFFFFF",
    display: "flex",
    justifyContent: "space-between",
    fontSize: 16,
    color: "#fff",
  },
  sidebar: {
    background: "rgba(255, 255, 255, 0.8)",
    boxShadow: "0px -6px 6px -2px rgb(0 0 0 / 75%)"
  },
  sidebarUserinfo: {
    textAlign: "center",
    paddingTop: 5,
    paddingBottom: 5,
    backgroundColor: "#fff"
  },
  widthAuto: {
    width: "auto",
  },
};

export default styles;
